module.exports = __webpack_public_path__ + "img/tilt-message.9c5c79bd.jpg";